import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';

/**
 * 維修報告 Detail。
 * GET `/aftersales/repair-report/{id}`
 * 回傳 data 已扁平 nested `inspection`／`history.refuseReason` → form 欄。
 *
 * @param {string} id
 */
export async function fetchRepairReportDetail(id) {
  const { data: raw } = await request.get(`/aftersales/repair-report/${id}`);
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeRepairReportDetail(parsed.data),
  };
}
